import PropTypes from 'prop-types';
import { FacebookShareButton, TwitterShareButton } from 'react-share';

import ConditionalLink from '@plone/volto/components/manage/ConditionalLink/ConditionalLink';

import { FacebookLogo } from '../Icons/FacebookLogo';
import { TwitterLogo } from '../Icons/TwitterLogo';
import { formatPublicationDate } from '../../helpers/formatPublicationDate';
import { getNewsImageStyle, getShareUrl } from '../../helpers/newsUtils';

const NewsSocialShare = ({ shareUrl, title, description }) => (
  <div className="news-item-social-container">
    <TwitterShareButton url={shareUrl} title={title} description={description}>
      <span className="news-social-icon twitter-icon">
        <TwitterLogo width={20} height={20} />
      </span>
    </TwitterShareButton>
    <FacebookShareButton url={shareUrl} quote={title}>
      <span className="news-social-icon">
        <FacebookLogo width={20} height={20} />
      </span>
    </FacebookShareButton>
  </div>
);

NewsSocialShare.propTypes = {
  shareUrl: PropTypes.string.isRequired,
  title: PropTypes.string,
  description: PropTypes.string,
};

const NewsList = ({
  items,
  firstPage = false,
  fakeItemsLastRow = 0,
  isEditMode = false,
  showSocialShare = true,
  loading = false,
}) => {
  const linkDisabled = isEditMode;
  const canShowSocialShare = showSocialShare && typeof window !== 'undefined';

  const fakeItems = Array.from({ length: fakeItemsLastRow }, (_, index) => (
    <div key={`fake-${index}`} className="news-item-container fake" />
  ));

  return (
    <div className={`news-container${loading ? ' loading' : ''}`}>
      {(items || []).map((item, index) => {
        const isNewest = index === 0 && firstPage;
        const shareUrl = getShareUrl(item['@id']);
        const itemClassName = `news-item-container${isNewest ? ' newest' : ''}`;

        const linkContent = (
          <>
            <div className="news-item-image" style={getNewsImageStyle(item)} />
            <div className="news-item-date">
              <span>{formatPublicationDate(item.effective)}</span>
            </div>
            {isNewest ? (
              <h3 className="news-item-title csj-heading3">{item.title}</h3>
            ) : (
              <h4 className="news-item-title csj-heading4">{item.title}</h4>
            )}
            {item.description && (
              <div className="news-item-description">
                <span>{item.description}</span>
              </div>
            )}
            <p className="news-item-readmore">... (llegir més)</p>
          </>
        );

        if (linkDisabled) {
          return (
            <div key={item['@id']} className={itemClassName}>
              {linkContent}
              {canShowSocialShare && (
                <NewsSocialShare
                  shareUrl={shareUrl}
                  title={item.title}
                  description={item.description}
                />
              )}
            </div>
          );
        }

        return (
          <div key={item['@id']} className={itemClassName}>
            <ConditionalLink className="news-item-link" item={item} condition>
              {linkContent}
            </ConditionalLink>
            {canShowSocialShare && (
              <NewsSocialShare
                shareUrl={shareUrl}
                title={item.title}
                description={item.description}
              />
            )}
          </div>
        );
      })}
      {fakeItems}
    </div>
  );
};

NewsList.propTypes = {
  items: PropTypes.arrayOf(PropTypes.object),
  firstPage: PropTypes.bool,
  fakeItemsLastRow: PropTypes.number,
  isEditMode: PropTypes.bool,
  showSocialShare: PropTypes.bool,
  loading: PropTypes.bool,
};

NewsList.defaultProps = {
  items: [],
  firstPage: false,
  fakeItemsLastRow: 0,
  isEditMode: false,
  showSocialShare: true,
  loading: false,
};

export default NewsList;
